import { useEffect } from "react";

const InactivityTracker = () => {
  const INACTIVITY_LIMIT = 40 * 60 * 1000; // ✅ 40 minutes
  const ACTIVITY_KEY = "lastActivityTime";

  // Save current time as last activity
  const updateLastActivity = () => {
    localStorage.setItem(ACTIVITY_KEY, Date.now().toString());
  };

  // Check if the user has been inactive
  const checkInactivity = () => {
    const lastActivity = localStorage.getItem(ACTIVITY_KEY);
    const lastTime = lastActivity ? parseInt(lastActivity, 10) : 0;
    const currentTime = Date.now();

    const isInactive = currentTime - lastTime > INACTIVITY_LIMIT;

    if (isInactive) {
      localStorage.clear();
      window.location.href = "/"; // redirect after clearing
    }
  };

  useEffect(() => {
    // Update activity on initial load
    // updateLastActivity();
    // checkInactivity();

    const lastActivity = localStorage.getItem(ACTIVITY_KEY);
    if (lastActivity) {
      checkInactivity();
    } else {
      updateLastActivity();
    }
    // Listen to user activity
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];
    events.forEach((event) =>
      window.addEventListener(event, updateLastActivity)
    );

    // Check inactivity every 5 seconds
    const intervalId = setInterval(checkInactivity, 60000);

    return () => {
      // Clean up
      events.forEach((event) =>
        window.removeEventListener(event, updateLastActivity)
      );
      clearInterval(intervalId);
    };
  }, []);

  return null;
};

export default InactivityTracker;
